import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class UnsavedFormChangesService {
  private isDirty = false;

  setDirty(isDirty: boolean): void {
    this.isDirty = isDirty;
  }

  checkUnsavedChanges(): boolean {
    return this.isDirty;
  }
}
